import React from 'react';
import styled from 'styled-components';

import { selectFiles } from '../../../core/services/file.service';

type EditCoverButtonProps = {
  onChange: (file: File) => void;
};

export const EditCoverButton: React.FC<EditCoverButtonProps> = ({ onChange }) => {
  const handleChange = async () => {
    const files = await selectFiles({ accept: 'image/png, image/webp, image/jpeg' });

    if (!files || files.length === 0) {
      return;
    }

    onChange(files[0]);
  };

  return (
    <EditCover id="edit" onClick={handleChange}>
      Edit
    </EditCover>
  );
};

const EditCover = styled.div`
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  font-size: 1.4rem;
  border-radius: var(--border-radius-small);
  padding: 0.2rem 0.8rem;
  color: white;
  background: black;
  opacity: 0;
  transform: translateX(1rem) scale(0.95);
  transition: all 0.1s ease-in;
  user-select: none;

  &:hover {
    cursor: pointer;
  }
`;
